import { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { formatDate, gridSize, gridSizeMdLg12, gridSizeMdLg4, newSolicitudesIngresoSchema, ROUTER_PATHS, texto } from "@/shared";
import {
  useCreateSolicitudesIngresos,

  useFetchUbicaciones,

  useUpdateSolicitudesIngresos,
} from "@/shared/actions/erp";
import {
  CustomAutocomplete,
  SampleDatePicker,
  SampleTable,
  TabTextLabel,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import {
  SolicitudesIngreso,
  SaveSolicitudIngresoFormData,
  IDataProducto,
} from "@/shared/interfaces";
import { Button, Grid, IconButton, Paper, TextField, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { MRT_ColumnDef } from "material-react-table";
import { useUiStore } from "@/store/ui";
import ProductoPedidosIngresoDynamicTable from "../../pages/detallesIngresoTableDynamic/detallesIngresoTableDynamic";
import { yupResolver } from "@hookform/resolvers/yup";
import { MaterialesKey, useBodegaStore, useMaterialesUtilizadosStore } from "@/store/erp";
import { BODEGAS, /* IUbicacionProducto, */ Ubicaciones } from "@/shared/interfaces/erp/inventario";
import SampleTextFieldNumber from "@/shared/components/ui/SampleTextFieldNumber/SampleTextFieldNumber";


const returnUrlSolicitudesIngreso = "/compras/solicitud-ingreso";



export interface SaveSolicitudesIngresoInterface {
  titlePage?: string;
  editSolicitudesIngreso?: SolicitudesIngreso;
}
const SaveSolicitudesIngreso: React.FC<SaveSolicitudesIngresoInterface> = ({
  editSolicitudesIngreso,
}) => {

  const [, setBodegaSelected] = useState(false);
  const [selectedBodega, setSelectedBodega] = useState<string>("");
  const [, setUbicacionSelected] = useState(false);
  const [selectedUbicacion, setSelectedUbicacion] = useState<string>("");
  ///* form
  const form = useForm<SaveSolicitudIngresoFormData>({
    resolver: yupResolver(newSolicitudesIngresoSchema),
  });

  const navigate = useNavigate();

  const productosSinSerie = useMaterialesUtilizadosStore(
    (s) => s.solicitudCompras
  );



  const [open, setOpen] = useState(false);

  ///* mutations
  const createSolicitudesIngresoMutation = useCreateSolicitudesIngresos({
    navigate,
    returnUrl: returnUrlSolicitudesIngreso,
  }
  );
  const updateSolicitudesIngresoMutation = useUpdateSolicitudesIngresos({
    navigate,
    returnUrl: returnUrlSolicitudesIngreso
  }
  );
  const removeSelectedItem = useMaterialesUtilizadosStore(
    (s) => s.removeSolicitudesComprasProducto
  );
  const clearProductoSinSeriesItems = useMaterialesUtilizadosStore(
    (s) => s.clearSolicitudesComprasProductos
  );
  const updateQuantityProductoItem = useMaterialesUtilizadosStore(
    (s) => s.updateQuantityProductoItem1
  );


  const { bodegas, isLoadingbodegas } = useBodegaStore();
  const { data: ubOrien, isLoading: isLoadingUb } = useFetchUbicaciones({
    page_size: 600,
    bodega: form.getValues().bodega
  }, !!form.watch('bodega'))
  //* update local storage
  const onChangeQuantity = useCallback(
    (value: any, item: any) => {
      updateQuantityProductoItem(
        {
          ...item,
          cantidad: `${value}`,
          descripcion: item.descripcion,
          codigo: item.codigo,
          cantidad_recibida: item.cantidad_recibida || 0,
          series: []
        },
        MaterialesKey.solicitudCompras
      );
    },
    [updateQuantityProductoItem]
  );
  const setAlert = useUiStore.getState().setAlert;
  const columns = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: "remove",
        header: "Eliminar",
        Cell: ({ row }) => {
          return (
            <Tooltip title="Eliminar">
              <IconButton
                onClick={() => {
                  removeSelectedItem(
                    row.original.id_producto,
                    MaterialesKey.solicitudCompras
                  )
                }}
              >
                <DeleteIcon style={{ color: "red" }} />
              </IconButton>

            </Tooltip>
          )
        }

      },
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'descripcion',
        header: 'Descripción',
        Cell: ({ row }) => row.original?.descripcion || 'N/A',
      },
      {
        accessorKey: 'modelo_producto',
        header: 'Modelo',
      },
      {
        accessorKey: 'marca_producto',
        header: 'Marca',
      },
      {
        accessorKey: 'categoria_producto',
        header: 'Categoria',
      },
      {
        accessorKey: 'unidad_medida',
        header: 'Medida',
        Cell: ({ row }) => row.original.unidad_medida || 'N/A'
      },
      {
        accessorKey: 'stock_actual',
        header: 'Stock Actual'
      },
      {
        accessorKey: "cantidad",
        header: "cantidad requerida",
        Cell: ({ row }) => {
          return (
            <SampleTextFieldNumber

              value={row.original.cantidad || 0}

              min={0}
              step={1}

              onChangeValue={(e) => {


                onChangeQuantity(e, {
                  ...row.original,
                  id: row.original.id_producto

                })
              }
              }
            />

          );
        },
      },
    ],
    [removeSelectedItem]
  );

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  const onSave = async () => {

    const cantidad = productosSinSerie.some(elemento => {
      return Number(elemento.cantidad) === 0
    })
    if (cantidad) {
      setAlert(
        true,
        "No puedes realizar la solicitud de pedido con productos de cantidad cero",
        "error"
      );
      return;
    }

    if (!isValid) return;
    if (!productosSinSerie || productosSinSerie.length === 0) {
      setAlert(
        true,
        "Para solicitar una solicitud de Ingreso debes seleccionar al menos un producto",
        "error"
      );
      return;
    }
    ///* upd
    if (editSolicitudesIngreso?.id_solicitudingreso) {
      return updateSolicitudesIngresoMutation.mutate(
        {
          id: editSolicitudesIngreso.id_solicitudingreso,
          data: {
            ...form.getValues(),
          } as any,
        },
        {
          onSuccess: () => {
            reset(); // reset form after successful update
            clearProductoSinSeriesItems();

          },
        }
      );
    }

    ///* create
    /* const resp = await createSolicitudesIngresoMutation.mutateAsync( */
    return createSolicitudesIngresoMutation.mutate(
      {
        ...form.getValues(),
        productos: productosSinSerie,
      } as any,
      {
        onSuccess: () => {
          reset();
          clearProductoSinSeriesItems();
        }
      }

    );

    /* if (resp.code === 200) {
      reset({ bodega: undefined, observaciones: '' });
      clearProductoSinSeriesItems();
    } */
  };

  ///* effects
  useEffect(() => {
    if (editSolicitudesIngreso) {
      reset({
        ...editSolicitudesIngreso,
      } as any);
    }
  }, [editSolicitudesIngreso]);

  useEffect(() => {
    return (

      clearProductoSinSeriesItems()

    )
  }, [])

  const onChangeBodegas = (value: string) => {
    setSelectedBodega(value)
    form.setValue("bodega", value);
    setBodegaSelected(true);
  }

  /* const productFilter = useMemo(() => {
    return ubOrigen.filter(ubicacion => ubicacion.bodega === selectedBodega)
  }, [ubOrigen, selectedBodega])
 */

  const onChangeUbicaciones = (value: string) => {
    setSelectedUbicacion(value)
    form.setValue("ubicacion", value);
    setUbicacionSelected(true);
  }

  const handleAgregarItems = () => {
    if (!selectedBodega || selectedBodega.trim() === '') {
      setAlert(
        true,
        "Para agregar al items debes seleccionar una bodega",
        "error"
      );
      // Mostrar la alerta si no se ha seleccionado una bodega válida
      return
    }

    if (!selectedUbicacion || selectedUbicacion.trim() === '') {
      setAlert(
        true,
        "Para agregar ítems debes seleccionar una ubicación",
        "error"
      );
      return;
    }

    // Lógica para agregar items cuando se ha seleccionado una bodega válida
    setOpen(true);
  }

  return (
    <>
      <SingleTableBoxScene
        title="Solicitud de Compra"
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.compras.solicitud_ingreso_nav}
        visibleReport={false}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onSave, () => {

          //console.log("error", error);

          for (let producto of productosSinSerie) {
            if (producto.cantidad === 0) {
              setAlert(
                true,
                "No se pueden enviar cantidades vacías, por favor verifica tu pedido",
                "error"
              );
              return;
            }
          }

        })}
      >
        <Grid container spacing={3}>

          <SampleDatePicker
            disabled={true}
            label="Fecha creación"
            control={control}
            error={errors.fecha_creacion}
            helperText={errors.fecha_creacion?.message}
            name="fecha_creacion"
            textFieldKey="fecha_creacion"
            size={gridSizeMdLg4}
            defaultValue={formatDate(new Date()) || ''}
          />
          <CustomAutocomplete<BODEGAS>
            size={gridSizeMdLg4}
            label={texto.bodega}
            name="bodega"
            options={bodegas || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().bodega || ''}
            isLoadingData={isLoadingbodegas}
            control={control}
            error={errors.bodega}
            helperText={errors.bodega?.message}
            onChangeValue={(e) => {
              onChangeBodegas(e)
              if (!e) return ({ ...form.getValues(), bodega: '', ubicacion: '' });
              reset({ ...form.getValues(), ubicacion: '' });
              // e && getUbOrigen({ bodega: e.codigo });
              ///e && getUbOrigen({ bodega: e.codigo });
            }}
          />

          {selectedBodega && form.getValues().bodega && (
            <CustomAutocomplete<Ubicaciones>
              size={gridSizeMdLg4}
              label={'Ubicación'}
              name="ubicacion"
              options={ubOrien?.data.data || []}
              //options={ubOrigen}
              valueKey="nombre"
              actualValueKey="codigo"
              defaultValue={form.getValues().ubicacion || null}
              isLoadingData={isLoadingUb}
              control={control}
              error={errors.ubicacion}
              helperText={errors.ubicacion?.message}
              onChangeValue={(e) => {
                onChangeUbicaciones(e)
              }}
            />
          )}


          <Grid item {...gridSizeMdLg12}>
            <TextField
              variant="outlined"
              label="Observación"
              multiline
              rows={2}
              fullWidth
              {...form.register("observaciones")}
              error={!!errors.observaciones}
              helperText={errors.observaciones?.message}
            />
          </Grid>
          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid
                container
                spacing={1}
                justifyContent={"space-between"}
                alignItems={"center"}
              >
                <Grid item>
                  <TabTextLabel
                    text={"Items Seleccionado"}
                    mt={0}
                    pb={0}
                    pl={0}
                    pt={0}
                  />
                </Grid>
                <Grid item>
                  <Button variant="outlined" onClick={handleAgregarItems}>Agregar Items</Button>
                </Grid>
                <div className="linea"></div>
                <Grid item xs={12}>
                  <SampleTable<IDataProducto>
                    columns={columns}
                    data={productosSinSerie}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        {
          open && (
            <ProductoPedidosIngresoDynamicTable open={open} setOpen={setOpen} ubicacion={selectedUbicacion} />
          )
        }
      </SingleTableBoxScene>
    </>
  );
};

export default SaveSolicitudesIngreso;